<template>
  <li
    :class="{
      user__item: true,
      'user__item--deleted': !!user.deletedAt
    }"
    tabindex="0"
  >
    <div class="user__inner" @click="node => handleUserView(node, user)">
      <div class="user__data">
        <div class="user__data-item user__name">
          <!-- eslint-disable-next-line -->
          <svg v-if="!!user.deletedAt" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="icon icon--danger"><path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z" class=""></path></svg>
          {{ user.firstName + " " + user.lastName }}
        </div>
        <div class="user__data-item user__email">{{ user.email }}</div>
      </div>
      <div class="user__item-options">
        <button
          @click="() => handleUserEdit(user)"
          class="user__item-option"
          title="Edit"
          type="button"
        >
          <span class="sr-only">Edit</span>
          <!-- eslint-disable-next-line -->
          <svg aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="icon"><path fill="currentColor" d="M290.74 93.24l128.02 128.02-277.99 277.99-114.14 12.6C11.35 513.54-1.56 500.62.14 485.34l12.7-114.22 277.9-277.88zm207.2-19.06l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.76 18.75-49.16 0-67.91z"></path></svg>
        </button>
        <button
          v-if="!!!user.deletedAt"
          @click="node => handleUserDelete(user)"
          class="user__item-option"
          title="Remove"
          type="button"
        >
          <span class="sr-only">Remove</span>
          <!-- eslint-disable-next-line -->
          <svg aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="icon"><path fill="currentColor" d="M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"></path></svg>
        </button>
        <button
          v-if="!!user.deletedAt"
          @click="node => handleUserRestore(user)"
          class="user__item-option"
          title="Restore"
          type="button"
        >
          <span class="sr-only">Restore</span>
          <!-- eslint-disable-next-line -->
          <svg aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="icon"><path fill="currentColor" d="M212.333 224.333H12c-6.627 0-12-5.373-12-12V12C0 5.373 5.373 0 12 0h48c6.627 0 12 5.373 12 12v78.112C117.773 39.279 184.26 7.47 258.175 8.007c136.906.994 246.448 111.623 246.157 248.532C504.041 393.258 393.12 504 256.333 504c-64.089 0-122.496-24.313-166.51-64.215-5.099-4.622-5.334-12.554-.467-17.42l33.967-33.967c4.474-4.474 11.662-4.717 16.401-.525C170.76 415.336 211.58 432 256.333 432c97.268 0 176-78.716 176-176 0-97.267-78.716-176-176-176-58.496 0-110.28 28.476-142.274 72.333h98.274c6.627 0 12 5.373 12 12v48c0 6.627-5.373 12-12 12z" class=""></path></svg>
        </button>
        <button
          @click="() => handleUserMore(user)"
          class="user__item-option"
          title="More"
          type="button"
        >
          <span class="sr-only">More</span>
          <!-- eslint-disable-next-line -->
          <svg aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="icon"><path fill="currentColor" d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z" class=""></path></svg>
        </button>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  name: "UserListItem",
  props: {
    user: {
      type: Object,
      default: () => {}
    },
    handleUserView: {
      type: Function,
      default: () => {}
    },
    handleUserEdit: {
      type: Function,
      default: () => {}
    },
    handleUserDelete: {
      type: Function,
      default: () => {}
    },
    handleUserMore: {
      type: Function,
      default: () => {}
    },
    handleUserRestore: {
      type: Function,
      default: () => {}
    }
  }
};
</script>

<style lang="scss">
.user {
  &__item {
    overflow: hidden;
    position: relative;

    &:hover {
      cursor: pointer;
    }

    &--deleted .user__data {
      color: $gray-500;
    }

    &-options {
      padding-right: 1rem;
      position: absolute;
      right: 100%;
      top: 0;
      width: 7.5rem;
    }

    &-option {
      background-color: transparent;
      border: 0;
      border-radius: 50%;
      cursor: pointer;
      height: 2rem;
      padding: 0;
      position: relative;
      width: 2rem;

      &:focus,
      &:hover {
        &:before {
          transform: scale(1);
          z-index: 1;
        }
      }

      &:before {
        background-color: $gray-200;
        border-radius: 50%;
        content: "";
        cursor: pointer;
        height: 100%;
        left: 0;
        pointer-events: none;
        position: absolute;
        overflow: hidden;
        top: 0;
        transform: scale(0);
        transition: transform 200ms;
        width: 100%;
        z-index: -1;
      }

      .icon {
        position: relative;
        width: 0.75rem;
        z-index: 1;
      }
    }
  }

  &__item:focus-within &__inner,
  &__item:hover &__inner {
    transform: translate(7.5rem);
    transition: transform 200ms ease-out 0ms;
  }

  &__inner {
    align-items: center;
    display: flex;
    min-height: 2rem;
    position: relative;
    transition: transform 200ms ease-out 50ms;
  }

  &__data {
    align-items: center;
    display: grid;
    flex: 1;
    grid-gap: 0.3125rem;
    grid-template-columns: repeat(2, 1fr);
    pointer-events: none;
    width: 100%;
  }
}

.icon {
  &--danger {
    color: $brand-danger;
    height: auto;
    width: 0.375rem !important;
  }
}
</style>
